import { IWalletEvent, IWalletEventMetadata } from 'meta/pages/v4/wallet'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  page: number
}

type Response = { items: Array<IWalletEvent>; metadata: IWalletEventMetadata }

export const getUpcomingGoodsServices = async (props: Props): Promise<Response> => {
  const { page } = props

  const { data, metadata } = await HttpRequestForApiV4.get<{ items: Array<IWalletEvent> }, IWalletEventMetadata>(
    ApiEndpoint.v4.wallet.upcomingGoodsServices(page)
  )

  return { items: data?.items ?? [], metadata: metadata ?? { currentPage: 0, hasMorePages: true } }
}
